// extracted by mini-css-extract-plugin
export default {"head":"styles_head__xzI4S","tableRow":"styles_tableRow__4g2Z2"};